import { useEffect, useState } from "react"
import {  PPTClassification } from "../../helpers/interfaces"
import { FormEditMode } from "../../helpers/constants"
import {  createPPTClassification, updatePPTClassification } from "../../apiServices/CTBMappingKeysApi"
import CustomDialog from "../CustomDialog"
import { Button } from "@mui/material"
import { Add } from "@mui/icons-material"
import { CustomTextField } from "../../layouts/themes"

interface Props {
   
    setFormEditMode: React.Dispatch<React.SetStateAction<number>>
    formEditMode: number
    setPPTClassification: React.Dispatch<React.SetStateAction<PPTClassification[]>>
    pptClassification: PPTClassification[]
    pptToEdit: string
    openPPTForm: boolean
    setOpenPPTForm: React.Dispatch<React.SetStateAction<boolean>>

}
function CreateEditPPT(props: Props) {
    const [pptName, setPPTName] = useState<string>("");
    
    useEffect(() => {
        if (props.formEditMode === FormEditMode.EDIT) {
            var afsName = props.pptClassification.find(e => e.id === props.pptToEdit)
            if (!afsName) return
            setPPTName(afsName.name)
           
        }
    }, [props.pptClassification, props.pptToEdit, props.formEditMode])

    function createNewPPTClassification() {
        createPPTClassification(pptName).then(_ppt => {
            props.setOpenPPTForm(false);
            props.setPPTClassification(ppt => [...ppt, _ppt])
            
        })
    }
    function updateNewPPTClassification() {
        updatePPTClassification(props.pptToEdit, pptName).then(result => {
            props.setOpenPPTForm(false);
            props.setPPTClassification(ppt => ppt.map(a=> a.id === props.pptToEdit ? result: a))
           
        })
    }
    return(
        <>
            <CustomDialog dialogTitle={props.formEditMode === FormEditMode.CREATE ? 'Add New PPT Classification ' : 'Update PPT Classification '} setOpenDialog={props.setOpenPPTForm} openDialog={props.openPPTForm}>
                <form>
                    <div >
                        <label className='title-label'>PPT Classification Name <span className='important'>*</span></label>
                    </div>
                    <div className='col-12'>
                    <div className="form-group mb-0">
                            <div className="">
                            <CustomTextField size="small" id="outlined-basic" placeholder="PPT Classification Name" value={pptName} onChange={(e) => setPPTName(e.target.value)} variant="outlined" sx={{width:'100%'}}/> 
                                
                            </div>
                        </div>
                    </div>
                    <br />
                   

                    <div className="form-group mt-3 mb-5" style={{ float: 'right' }}>
                        <Button disabled={!pptName} variant="contained" color='secondary' onClick={props.formEditMode === FormEditMode.CREATE ? createNewPPTClassification : updateNewPPTClassification} >
                            <Add />&nbsp; {props.formEditMode === FormEditMode.CREATE ? 'Add PPT Classification' : 'Update PPT Classification'}
                        </Button>
                    </div>
                </form >


            </CustomDialog>

        </>
    )
}
export default CreateEditPPT